import O1HD from "../../../../engines/gameEngine";
import {ChickEntity, getYoungList} from "./config/ChickConfig";
import PurchaseItemPrefab from "./PurchaseItemPrefab";
import ChickenPrefab from "./ChickenPrefab";

const {ccclass, property} = cc._decorator;
/**
 * 鸡购买
 */
@ccclass
export default class ChickenPurchaseNode extends cc.Component {

    @property(cc.Node)
    contentNode : cc.Node = null;
    @property(cc.Prefab)
    purchaseItemPrefab : cc.Prefab = null;

    private mParentScript : ChickenPrefab;

    onLoad () {

    }

    start () {

    }

    bindData( parentScript : ChickenPrefab ){
        this.mParentScript = parentScript;
        this.loadData();
    }

    loadData(){
        let dataList : ChickEntity[] = getYoungList();
        for ( let dataItem of dataList ) {
            let purchaseItemNode = cc.instantiate( this.purchaseItemPrefab );
            purchaseItemNode.getComponent( PurchaseItemPrefab ).bindData( dataItem , this.mParentScript );
            this.contentNode.addChild( purchaseItemNode );
        }
    }

    /**
     * 关闭
     */
    onBtnClose(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.node.removeFromParent();
        this.node.destroy();
    }


}
